module.exports = __webpack_public_path__ + "0790e9c8cf4ee56884d15d868503b4ea.svg";